// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminPage_container__3PZUs","title":"AdminPage_title__3pvVX","users":"AdminPage_users__3V1BV","list":"AdminPage_list__1X019"};